export enum FormFM1ClientType {
  /** Частная компания OQAM Finance Ltd */
  OQAM_Finance_Ltd = 'OQAM_Finance_Ltd',
  /** Частная компания NGDEM Global Limited */
  NGDEM_Global_Limited = 'NGDEM_Global_Limited',
  /** Esentai Asset Management Ltd */
  Esentai_Asset_Management_Ltd = 'Esentai_Asset_Management_Ltd',
}

export interface GenerateFormFM1Params {
  cnyKzt: number;
  eurKzt: number;
  rubKzt: number;
  usdKzt: number;
  aedKzt: number;
  thresholdValue: number;
  currency: 'USD';
  file: File;
  clients: FormFM1ClientType[];
}
